import React from 'react';
import { CnLayoutCol as UICnLayoutCol } from "../../components/cn-layout";
var CnLayoutCol = function CnLayoutCol(props) {
  var _ref = props || {},
    children = _ref.children;
  return /*#__PURE__*/React.createElement(UICnLayoutCol, null, children);
};
CnLayoutCol.displayName = 'CnLayoutCol';
export default CnLayoutCol;
export { CnLayoutCol };